import { getBridgeSdk, getUserInfo, NEWRELIC_TABLES, recordNREvent, User } from "@swiggy-private/checkout-core";
import { syncClientHeaders } from "./Header";
import { captureError } from "@swiggy-private/core-ui";

/**
 * Sets a flag in sessionStorage to track that user is coming from login flow.
 * This flag is used for back navigation handling to redirect to menu page instead of homepage.
 */
export const setCartFromLoginFlowFlag = (): void => {
    const isSessionStorageAvailable = typeof window !== "undefined" && typeof sessionStorage !== "undefined";
    if (isSessionStorageAvailable) {
        sessionStorage.setItem("cart_from_login_flow", "true");
    }
};

export const goToLogin = async (
    source: string,
    reloadCart: VoidFunction,
    setUser: (user: User) => void,
    prevPathWeb?: string,
): Promise<boolean> => {
    try {
        setCartFromLoginFlowFlag();
        
        return getBridgeSdk()
            .login({ prevPathWeb })
            .then(async response => {
                if (!response || !response.hasLoggedIn) {
                    return false;
                }
                recordNREvent({
                    eventType: NEWRELIC_TABLES.POST_LOGIN_FLOW,
                    source,
                });
                await syncClientHeaders();

                // update User Context
                getUserInfo()
                    .then(data => data.isSome() && setUser(data.unwrap()))
                    .catch(captureError);
                reloadCart();
                return true;
            });
    } catch (err) {
        captureError(err);
        return false;
    }
};
